import React from 'react';
import Anime from 'react-anime';
import './LeftPipe.scss';
export default () => {
  const moveBall = {
    marginLeft: [
      { value: '-50%', duration: 0 },
      { value: (el, i) => window.innerWidth < 767 ? '25%' : '25%', duration: 1000, easing: 'linear'}
    ],
    marginTop: [
      { value: 'auto', duration: 0 },
      { value: '120%', duration: 1500, delay: 1000, easing: 'linear'}
    ]
  }
  return (
    <div className="left-elbow-pipe">
      <Anime {...moveBall} className="ball">
        <div></div>
      </Anime>
    </div>
  );
}